import { PAGE_SCALE_DOWN } from "./actionTypes";

export const setScalePageDown = scaleFactor => {
  return {
    type: PAGE_SCALE_DOWN,
    payload: scaleFactor
  };
};
